import React, { useContext, useEffect, useState } from "react";
import { Flex, Input, Heading, TextArea, Select, Text, MRadio, Checkbox, Button } from "@cisco/spaces-dash-lib-styleguide";
import "./app-tile-tab.scss";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { v4 as uuidv4 } from "uuid";
import { I18nContext } from "../../../contexts/i18nContext";
import { PropertiesContext } from "../../../contexts/propertiesContext";

function AppTileTab(props) {
  const { action, type, app, selectedAppType, setApp } = props;
  const i18n = useContext(I18nContext);
  const { properties } = useContext(PropertiesContext);
  const [appAutoActivation, setAppAutoActivation] = useState(false);
  const handleInput = (event, field) => {
    const newEditingNode = { ...app };
    newEditingNode.appTile[field] = event.target.value;
    setApp(newEditingNode);
  };
  const defaultLaunchInstructions = {
    isNotes: false,
    link: "",
    notes: `Step 1: To launch your app, please visit here.`
  };

  const handleCustomInput = (event, field, field2, isBoolean) => {
    const newEditingNode = { ...app };
    if (newEditingNode.appTile[field] && newEditingNode.appTile[field][field2] !== undefined && newEditingNode.appTile[field][field2] !== null) {
      newEditingNode.appTile[field][field2] = isBoolean ? JSON.parse(event.target.value) : event.target.value;
    } else {
      newEditingNode.appTile[field] = { ...defaultLaunchInstructions };
      newEditingNode.appTile[field][field2] = isBoolean ? JSON.parse(event.target.value) : event.target.value;
    }
    setApp(newEditingNode);
  };

  const [instructionNotes, setInstructionNotes] = useState(
    i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.to-activate-app-msg") + i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.paste-copied-activation-token-msg")
  );

  const hoursMax = 99;
  const minutesMax = 59;
  const [hoursList, setHoursList] = useState([]);
  const [minutesList, setMinutesList] = useState([]);
  const [selectedHourItem, setSelectedHourItem] = useState("1");
  const [selectedMinItem, setSelectedMinItem] = useState("0");

  const [redirectUrl, setRedirectUrl] = useState("");

  const prepareMinutesHours = () => {
    let i = 0;
    const hoursListCpy = [...hoursList];
    const minutesListCpy = [...minutesList];
    while (i <= hoursMax) {
      hoursListCpy.push({ label: `${i}`, value: `${i}` });
      i++;
    }
    setHoursList(hoursListCpy);

    let j = 0;
    while (j <= minutesMax) {
      minutesListCpy.push({ label: `${j}`, value: `${j}` });
      j++;
    }
    setMinutesList(minutesListCpy);
  };

  const calculateMinutesHoursForPreselection = () => {
    if (app.appTile && app.appTile.activationTokenDuration !== null && app.appTile.activationTokenDuration !== undefined) {
      const selectedMinutes = app.appTile.activationTokenDuration;
      const hour = Math.floor(selectedMinutes / 60);
      const minutes = selectedMinutes % 60;
      setSelectedHourItem(hour.toString());
      setSelectedMinItem(minutes.toString());
    }
  };

  useEffect(() => {
    console.log("AppTileTab Mount", properties);
    prepareMinutesHours();
    console.log(appAutoActivation);
    if (app.appTile.activationTokenDuration !== null && app.appTile.activationTokenDuration !== undefined) {
      calculateMinutesHoursForPreselection();
    } else {
      // handleInput({target: {value: "60"}}, "activationTokenDuration");
    }
    if (props)
      if (selectedAppType == "On-Prem" || type == "On-Prem") {
        if (app.appTile.instructionNotes === undefined || app.appTile.instructionNotes === null) {
          // instruction notes
        } else {
          setInstructionNotes(app.appTile.instructionNotes);
        }
        if (app.appTile.launchInstructions === undefined || app.appTile.launchInstructions === null) {
          const newEditingNode = { ...app };
          newEditingNode.appTile.launchInstructions = {
            ...defaultLaunchInstructions
          };
          setApp(newEditingNode);
        }
      }

    if (app.appTile.thirdPartyOauth === undefined || app.appTile.thirdPartyOauth === null) {
      const newEditingNode = { ...app };
      newEditingNode.appTile.thirdPartyOauth = false;
      setApp(newEditingNode);
    }
    if (action === "create" && type == "MTC") {
      const newEditingNode = { ...app };
      newEditingNode.appTile.oAuth = true;
      setApp(newEditingNode);
    }
    if (app.appTile.oAuth && !app.appTile.thirdPartyOauth) {
      // newEditingNode.prepareEditOAuthUrls();
    }
    if (app.appTile.enableAutoActivation) {
      setAppAutoActivation(true);
    }
    return () => {
      console.log("AppTileTab Destroy");
    };
  }, []);

  useEffect(() => {
    if (properties) {
      console.log("AppTileTab properties", properties);
      setRedirectUrl(`${properties.partnerSandboxBaseUrl}${properties.partnerOauthRedirectionUri}`);

      // const hardCodedObj = {
      //   defaultUSAppDashboardUrl: "https://partnersite.qa-dnaspaces.io/auth/appLogin",
      //   defaultUSOAuthLoginUrl: "https://partnersite.qa-dnaspaces.io/auth/login",
      //   defaultUSOAuthTokenUrl: "https://partnersite.qa-dnaspaces.io/auth/token",
      //   defaultUSAppInfoUrl: "https://partnersite.qa-dnaspaces.io/appInfo",
      //   defaultEUAppDashboardUrl: "https://partnersite.qa-dnaspaces.io/auth/appLogin",
      //   defaultEUOAuthLoginUrl: "https://partnersite.qa-dnaspaces.io/auth/login",
      //   defaultEUOAuthTokenUrl: "https://partnersite.qa-dnaspaces.io/auth/token",
      //   defaultEUAppInfoUrl: "https://partnersite.qa-dnaspaces.io/appInfo"
      // };
      const hardCodedObj = {};

      const newPproperties = { ...properties, ...hardCodedObj };

      const {
        defaultEUAppDashboardUrl,
        defaultUSAppDashboardUrl,
        defaultEUOAuthLoginUrl,
        defaultUSOAuthLoginUrl,
        defaultEUOAuthTokenUrl,
        defaultUSOAuthTokenUrl,
        defaultEUAppInfoUrl,
        defaultUSAppInfoUrl
      } = newPproperties;

      if (action === "create" && type == "MTC") {
        const newEditingNode = { ...app };
        if (app.region === "us") {
          if (newEditingNode.appTile.dashboardUrl == defaultEUAppDashboardUrl || newEditingNode.appTile.dashboardUrl === undefined || newEditingNode.appTile.dashboardUrl === null)
            newEditingNode.appTile.dashboardUrl = defaultUSAppDashboardUrl;
          if (newEditingNode.appTile.oAuthLoginURL == defaultEUOAuthLoginUrl || newEditingNode.appTile.oAuthLoginURL === undefined || newEditingNode.appTile.oAuthLoginURL === null)
            newEditingNode.appTile.oAuthLoginURL = defaultUSOAuthLoginUrl;
          if (newEditingNode.appTile.oAuthTokenURL == defaultEUOAuthTokenUrl || newEditingNode.appTile.oAuthTokenURL === undefined || newEditingNode.appTile.oAuthTokenURL === null)
            newEditingNode.appTile.oAuthTokenURL = defaultUSOAuthTokenUrl;
          if (newEditingNode.appTile.partnerAppInfoURL == defaultEUAppInfoUrl || newEditingNode.appTile.partnerAppInfoURL === undefined || newEditingNode.appTile.partnerAppInfoURL === null)
            newEditingNode.appTile.partnerAppInfoURL = defaultUSAppInfoUrl;
        }
        if (app.region === "eu" || app.region === "sg") {
          if (newEditingNode.appTile.dashboardUrl == defaultUSAppDashboardUrl || newEditingNode.appTile.dashboardUrl === undefined || newEditingNode.appTile.dashboardUrl === null)
            newEditingNode.appTile.dashboardUrl = defaultEUAppDashboardUrl;
          if (newEditingNode.appTile.oAuthLoginURL == defaultUSOAuthLoginUrl || newEditingNode.appTile.oAuthLoginURL === undefined || newEditingNode.appTile.oAuthLoginURL === null)
            newEditingNode.appTile.oAuthLoginURL = defaultEUOAuthLoginUrl;
          if (newEditingNode.appTile.oAuthTokenURL == defaultUSOAuthTokenUrl || newEditingNode.appTile.oAuthTokenURL === undefined || newEditingNode.appTile.oAuthTokenURL === null)
            newEditingNode.appTile.oAuthTokenURL = defaultEUOAuthTokenUrl;
          if (newEditingNode.appTile.partnerAppInfoURL == defaultUSAppInfoUrl || newEditingNode.appTile.partnerAppInfoURL === undefined || newEditingNode.appTile.partnerAppInfoURL === null)
            newEditingNode.appTile.partnerAppInfoURL = defaultEUAppInfoUrl;
        }
        setApp(newEditingNode);
      }
    }
  }, [properties]);

  const onSelectHours = (val) => {
    console.log("selected hours", val);
    setSelectedHourItem(val);
    const duration = JSON.parse(val) * 60 + JSON.parse(selectedMinItem);
    handleInput({ target: { value: duration } }, "activationTokenDuration");
  };

  const onSelectMinutes = (val) => {
    console.log("selected minutes", val);
    setSelectedMinItem(val);
    const duration = JSON.parse(selectedHourItem) * 60 + JSON.parse(val);
    handleInput({ target: { value: duration } }, "activationTokenDuration");
  };

  const onChangeInstructionNotes = (event, editor) => {
    console.log("event", event, editor.getData());
    handleInput({ target: { value: editor.getData() } }, "instructionNotes");
  };

  const onChangeLaunchInstructionNotes = (event, editor) => {
    console.log("event", event, editor.getData());
    handleCustomInput({ target: { value: editor.getData() } }, "launchInstructions", "notes", false);
  };

  const onChangeLaunchType = (val) => {
    console.log("onChangeLaunchType", val);
    handleCustomInput(val, "launchInstructions", "isNotes", true);
  };

  const onChangeLaunchLink = (val) => {
    console.log("onChangeLaunchType", val);
    handleCustomInput(val, "launchInstructions", "link", false);
  };

  const regenerateClientSecret = () => {
    const newEditingNode = { ...app };
    let clientSecretUUID = uuidv4();
    clientSecretUUID = clientSecretUUID.replace(/-/g, "").toLowerCase();
    let appendStr = "";
    appendStr = uuidv4().replace(/-/g, "").toLowerCase();
    clientSecretUUID += appendStr.substring(0, 8);
    newEditingNode.appTile.clientSecret = clientSecretUUID;
    setApp(newEditingNode);
  };

  const onPremStcTemplate = () => {
    return (
      <>
        <Flex direction="vertical" gap={8}>
          <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.activation-token-Validity-duration-text")}</Heading>
          <Text size="p3" weight="regular">
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.in-minutes-text")}
          </Text>
        </Flex>
        <Flex className="formMaxWidth4" direction="vertical" gap={8}>
          {hoursList && hoursList.length ? (
            <div>
              <Select onChange={onSelectHours} options={hoursList} value={selectedHourItem} />
              <Text className="mds-rebuild-input-size-md">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.hour-text")}</Text>
            </div>
          ) : (
            ""
          )}
        </Flex>
        <Flex className="formMaxWidth4" direction="vertical" gap={8}>
          {minutesList && minutesList.length ? (
            <div>
              <Select onChange={onSelectMinutes} options={minutesList} value={selectedMinItem} />
              <Text className="mds-rebuild-input-size-md">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.minutes-text")}</Text>
            </div>
          ) : (
            ""
          )}
        </Flex>
        <Flex className="formMaxWidth540" direction="vertical" gap={8}>
          <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-activation-instructions-text")}</Heading>
          {type === "On-Prem" && (
            <Text size="p3" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.on-prem-apps-activated-text")}
            </Text>
          )}
          {type === "STC" && (
            <Text size="p3" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.single-tenant-apps-activated-text")}
            </Text>
          )}
        </Flex>
        <Flex className="formMaxWidth540 ckeditorCustomStyle" direction="vertical" gap={8}>
          {/* <TextArea
            onChange={(e) => {
              handleInput(e, "instructionNotes");
            }}
            value={props.app.appTile.instructionNotes}
          /> */}
          <CKEditor
            editor={ClassicEditor}
            data={instructionNotes}
            onReady={(editor) => {
              // You can store the "editor" and use when it is needed.
              console.log("Editor is ready to use!", editor);
            }}
            onChange={onChangeInstructionNotes}
          />
        </Flex>
        {type === "On-Prem" && (
          <Flex className="formMaxWidth540" direction="vertical" gap={8}>
            <Flex direction="vertical" gap={8}>
              <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-launch-configuration-text")}</Heading>
              <Text size="p3" weight="regular">
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.on-prem-apps-launch-text")}
              </Text>
            </Flex>
            <Flex direction="vertical" gap={8}>
              <MRadio
                direction="horizontal"
                onChange={onChangeLaunchType}
                value={app.appTile?.launchInstructions?.isNotes}
                options={[
                  {
                    key: 1,
                    label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-launch-link-text"),
                    value: false
                  },
                  {
                    key: 2,
                    label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.launch-instruction-notes-text"),
                    value: true
                  }
                ]}
                size="md"
              />
            </Flex>
            {app.appTile && app.appTile.launchInstructions && !app.appTile.launchInstructions.isNotes && (
              <Flex className="formMaxWidth4" direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={onChangeLaunchLink}
                  value={app.appTile.launchInstructions.link}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-launch-link-text")}
                />
              </Flex>
            )}
            {app.appTile && app.appTile.launchInstructions && app.appTile.launchInstructions.isNotes && (
              <Flex className="formMaxWidth540 ckeditorCustomStyle" direction="vertical" gap={8}>
                <CKEditor
                  className="ckeditorCustomStyle"
                  editor={ClassicEditor}
                  data={app.appTile.launchInstructions.notes}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                  }}
                  onChange={onChangeLaunchInstructionNotes}
                />
              </Flex>
            )}
          </Flex>
        )}
      </>
    );
  };

  const onChangeOauthType = (val) => {
    console.log("autoActivation", val);
    handleInput(val, "autoActivation");
  };

  const onClickOauthCheckbox = () => {
    // console.log("oAuth", evt.val);
    const newEditingNode = { ...app };
    newEditingNode.appTile.oAuth = !newEditingNode.appTile.oAuth;
    console.log("oAuth", newEditingNode.appTile.oAuth);
    setApp(newEditingNode);
  };

  const mtcTemplate = () => {
    return (
      <Flex className="formMaxWidth4" direction="vertical" gap={16}>
        <Flex direction="vertical" gap={8}>
          <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.app-settings.new-app-activation-text")}</Heading>
        </Flex>
        <Flex className="formMaxWidth4" direction="vertical" gap={8}>
          {app.appTile?.enableAutoActivation && (
            <Flex>
              <Flex direction="vertical" gap={8}>
                <MRadio
                  direction="horizontal"
                  onChange={onChangeOauthType}
                  value={app.appTile?.autoActivation}
                  options={[
                    {
                      key: 1,
                      label: `${i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.enable-oauth-to-activate-app-text")} (${i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.checkbox-enable-oauth-for-app-text")})`,
                      value: false
                    },
                    {
                      key: 2,
                      label: `${i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.use-auto-activation-text")} (${i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.checkbox-enable-not-oauth-for-app-text")})`,
                      value: true
                    }
                  ]}
                  size="md"
                />
              </Flex>
              <Flex direction="vertical" gap={8}>
                <Input
                  size="md"
                  onChange={(e) => {
                    handleInput(e, "autoActivationURL");
                  }}
                  value={app.appTile?.autoActivationURL}
                  label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.landing-page-url-text")}
                />
              </Flex>
            </Flex>
          )}
        </Flex>
        <Flex className="formMaxWidth4" direction="vertical" gap={8}>
          {!app.appTile?.enableAutoActivation && (
            <Flex className="formMaxWidth4" direction="vertical" gap={4}>
              <Checkbox className="boldFont" id="oauth" key="oauth" onClick={() => onClickOauthCheckbox()} checked={app.appTile?.oAuth}>
                <Text size="p3" weight="semi-bold">
                  {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.oauth-text")} *
                </Text>
              </Checkbox>
              <div className="evtDesc">
                <Text size="p3" weight="semi-bold">
                  {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.checkbox-enable-oauth-text")}
                </Text>
              </div>
              <div className="evtDesc">
                <Flex className="formMaxWidth4" direction="vertical" gap={24}>
                  <Flex direction="vertical" gap={8}>
                    <Input
                      size="md"
                      onChange={(e) => {
                        handleInput(e, "clientId");
                      }}
                      value={app.appTile?.clientId}
                      label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.client-id-text")}
                    />
                  </Flex>
                  <Flex direction="vertical" gap={4}>
                    <Input
                      size="md"
                      onChange={(e) => {
                        handleInput(e, "clientSecret");
                      }}
                      value={app.appTile?.clientSecret}
                      label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.client-secret-text")}
                    />
                    {action !== "view" && (
                      <Button
                        style={{ "max-width": "160px" }}
                        kind="secondary"
                        onClick={() => {
                          regenerateClientSecret();
                        }}
                      >
                        {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.regenerate-secret-text")}
                      </Button>
                    )}
                  </Flex>
                  <Flex direction="vertical" gap={8}>
                    <Text size="p3" weight="semi-bold">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.redirect-uri-text")}
                    </Text>
                    <Text size="p3" weight="regular">
                      {redirectUrl}
                    </Text>
                  </Flex>
                  <Flex direction="vertical" gap={8}>
                    <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.oauth-url-config-text")}</Heading>
                  </Flex>
                  <Flex direction="vertical" gap={4}>
                    <Text size="p3" weight="semi-bold">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-dashboard-url-text")}
                    </Text>
                    <Text size="p3" weight="regular">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")} - https://
                    </Text>
                    <Input
                      size="md"
                      onChange={(e) => {
                        handleInput(e, "dashboardUrl");
                      }}
                      value={app.appTile?.dashboardUrl}
                    />
                  </Flex>
                  <Flex direction="vertical" gap={4}>
                    <Text size="p3" weight="semi-bold">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.oauth-login-url-text")}
                    </Text>
                    <Text size="p3" weight="regular">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")} - https://
                    </Text>
                    <Input
                      size="md"
                      onChange={(e) => {
                        handleInput(e, "oAuthLoginURL");
                      }}
                      value={app.appTile?.oAuthLoginURL}
                    />
                  </Flex>
                  <Flex direction="vertical" gap={4}>
                    <Text size="p3" weight="semi-bold">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.oauth-token-url-text")}
                    </Text>
                    <Text size="p3" weight="regular">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")} - https://
                    </Text>
                    <Input
                      size="md"
                      onChange={(e) => {
                        handleInput(e, "oAuthTokenURL");
                      }}
                      value={app.appTile?.oAuthTokenURL}
                    />
                  </Flex>
                  <Flex direction="vertical" gap={4}>
                    <Text size="p3" weight="semi-bold">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-info-url-text")}
                    </Text>
                    <Text size="p3" weight="regular">
                      {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")} - https://
                    </Text>
                    <Input
                      size="md"
                      onChange={(e) => {
                        handleInput(e, "partnerAppInfoURL");
                      }}
                      value={app.appTile?.partnerAppInfoURL}
                    />
                  </Flex>
                </Flex>
              </div>
            </Flex>
          )}
        </Flex>
      </Flex>
    );
  };

  return (
    <div className="pBottom40">
      <div>
        <Flex direction="vertical" gap={16}>
          <Flex direction="vertical" gap={8}>
            <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-tile-configuration-text")}</Heading>
            <Text size="p3" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.end-devices.end-device-config.fields-marked-mandatory-text")}
            </Text>
          </Flex>
          <Flex className="formMaxWidth4" direction="vertical" gap={8}>
            <Input
              className="fontWeightFix"
              size="md"
              onChange={(e) => {
                handleInput(e, "label");
              }}
              value={app.appTile.label}
              label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-tile-label-text")}
              required
            />
          </Flex>
          <Flex className="formMaxWidth4" direction="vertical" gap={8}>
            <TextArea
              onChange={(e) => {
                handleInput(e, "tagline");
              }}
              value={app.appTile.tagline}
              label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-view-app-tile.app-tile-tagline-text")}
              required
            />
          </Flex>
          {type !== "MTC" && onPremStcTemplate()}
          {type === "MTC" && mtcTemplate()}
        </Flex>
      </div>
    </div>
  );
}

export default AppTileTab;
